module.exports = "./img/2b406759bd2f63693244abb9dda08fb1.png";